{
  "cp.components.appDrawer.drawerCourses": "Corsi",
  "cp.components.appDrawer.drawerExport": "Esporta",
  "cp.components.appDrawer.drawerImprint": "Termini",
  "cp.components.appDrawer.drawerInstitutes": "Istituti",
  "cp.components.appDrawer.drawerSettings": "Impostazioni",
  "cp.components.appDrawer.drawerShares": "Condivisioni",
  "cp.components.appDrawer.drawerSingleTrainings": "Formazioni",
  "cp.components.appDrawer.drawerTrainees": "Tirocinanti",
  "cp.components.appDrawer.drawerTrainers": "Formatori",
  "cp.components.changePassword.changePasswordButton": "Cambia la password",
  "cp.components.changePassword.currentPassword": "Password attuale",
  "cp.components.changePassword.equalError": "La nuova password è uguale a quella vecchia",
  "cp.components.changePassword.matchError": "Le nuove password non coincidono",
  "cp.components.changePassword.newPassword": "Nuova password",
  "cp.components.changePassword.newPasswordRepeat": "Nuova password (ripetizione)",
  "cp.components.changePassword.newRequiredError": "È necessaria una nuova password",
  "cp.components.changePassword.newToShortError": "La password inserita è troppo breve.",
  "cp.components.changePassword.requiredError": "È necessaria la password corrente",
  "cp.components.changePassword.setPasswordButton": "Imposta la password",
  "cp.components.changeUserRole.errorSnackbar": "Si è verificato un errore sconosciuto. Riprova o contatta l'assistenza se l'errore persiste.",
  "cp.components.changeUserRole.selectLabel": "Scegli il ruolo",
  "cp.components.changeUserRole.successSnackbar": "Ruolo cambiato in {role}",
  "cp.components.courseTable.deleteLabel": "elimina",
  "cp.components.courseTable.downloadCSVTitle": "Scarica il file CSV",
  "cp.components.courseTable.downloadMessage": "Corso selezionato per il download",
  "cp.components.courseTable.selected": "selezionato",
  "cp.components.courseTable.tableRowAssociatedTrainer": "Formatore Associato",
  "cp.components.courseTable.tableRowDate": "Data",
  "cp.components.courseTable.tableRowIdentifier": "ID del corso",
  "cp.components.courseTable.tableRowLocation": "Posizione",
  "cp.components.courseTable.tableRowProvider": "Fornitore della formazione",
  "cp.components.courseTable.tableRowTraineeCount": "Conteggio dei tirocinanti",
  "cp.components.courseTable.tableRowValue": "Valore",
  "cp.components.dialog.confirmDeletion.contentConclusion": "L'eliminazione è definitiva. Questo account non sarà più disponibile.",
  "cp.components.dialog.confirmDeletion.contentDescription": "Stai per eliminare un account con i seguenti ruoli:",
  "cp.components.dialog.confirmDeletion.title": "Eliminare l'account selezionato?",
  "cp.components.footer.rightsReserved": "Tutti i diritti riservati.",
  "cp.components.general.institutePageSnackbarError": "Errore di salvataggio dell'istituto",
  "cp.components.general.institutePageSnackbarSuccess": "Salvato",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "L'E-mail è stata inviata negli ultimi 10 minuti. Attendi prima di poterne inviare un altro.",
  "cp.components.general.tableRowName": "Nome",
  "cp.components.genericTable.emptyMessage": "Vuoto",
  "cp.components.genericTable.multiSelect": "seleziona tutto",
  "cp.components.genericTable.nextPage": "pagina successiva",
  "cp.components.genericTable.previousPage": "pagina precedente",
  "cp.components.genericTable.rowsPerPageLabel": "Righe per pagina:",
  "cp.components.genericTable.searchPlaceholder": "Cerca",
  "cp.components.imprint.pageTitle": "Termini",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "Invita amministratore",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "Utenti autorizzati a gestire l'istituto",
  "cp.components.instituteAdminTable.adminsTableTitle": "Amministratori",
  "cp.components.instituteAdminTable.deleteAdminMessage": "Vuoi davvero eliminare l'amministratore selezionato? L'operazione è permanente.",
  "cp.components.instituteAdminTable.deleteLabel": "elimina",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "Vuoi veramente cancellare il formatore selezionato? L'operazione è permanente.",
  "cp.components.instituteAdminTable.name": "Nome",
  "cp.components.instituteAdminTable.selected": "selezionato",
  "cp.components.instituteForm.institute": "Istituto",
  "cp.components.instituteForm.instituteAddress": "Indirizzo dell'istituto",
  "cp.components.instituteForm.instituteCity": "Città",
  "cp.components.instituteForm.instituteCountry": "Paese",
  "cp.components.instituteForm.instituteName": "Nome dell'istituto",
  "cp.components.instituteForm.instituteSaveButton": "Salva",
  "cp.components.instituteForm.instituteState": "Stato",
  "cp.components.instituteForm.instituteStreet": "Via e numero civico",
  "cp.components.instituteForm.instituteStreetAdditional": "Aggiunta all'indirizzo",
  "cp.components.instituteForm.instituteZIP": "CAP",
  "cp.components.instituteForm.localeDanish": "Dansk",
  "cp.components.instituteForm.localeEnglish": "Inglese",
  "cp.components.instituteForm.localeFinish": "Suomi",
  "cp.components.instituteForm.localeFrench": "Français",
  "cp.components.instituteForm.localeGerman": "Deutsch",
  "cp.components.instituteForm.localeItalian": "Italiano",
  "cp.components.instituteForm.localeLabel": "Lingua",
  "cp.components.instituteForm.localeSpanish": "Espanol",
  "cp.components.instituteResultConfig.button": "Configura il feedback sul risultato",
  "cp.components.instituteResultConfig.info": "Queste modifiche vengono applicate all'intero istituto. Perché ciò accada, i formatori devono accedere nuovamente all'app CorPatch® Trainer. ",
  "cp.components.instituteResultConfig.save": "Salva configurazione",
  "cp.components.instituteResultConfig.thresholdGood": "Soglia Buono",
  "cp.components.instituteResultConfig.thresholdGreat": "Soglia Ottimo",
  "cp.components.instituteTrainerTable.button": "Invita Formatore",
  "cp.components.instituteTrainerTable.deleteLabel": "elimina",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "selezionato",
  "cp.components.instituteTrainerTable.subtitle": "Tutti i formatori appartenenti all'istituto\n",
  "cp.components.instituteTrainerTable.tableRowsStreet": "Strada",
  "cp.components.instituteTrainerTable.title": "Formatori",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "Ancora nessun formatore",
  "cp.components.invite.inviteCancelButton": "Annulla",
  "cp.components.invite.inviteEmailRequired": "Email",
  "cp.components.invite.inviteEmailSend": "Inviato",
  "cp.components.invite.inviteEmailSent": "E-mail inviata.",
  "cp.components.invite.inviteFirstnameLabel": "Nome",
  "cp.components.invite.inviteInvalidEmail": "Questo non è un indirizzo E-mail valido",
  "cp.components.invite.inviteOk": "OK",
  "cp.components.invite.inviteSendButton": "Invia invito",
  "cp.components.invite.inviteSubheader": "Un invito verrà inviato a questo indirizzo E-mail.",
  "cp.components.invite.inviteSurnameLabel": "Cognome",
  "cp.components.navBar.menuLabel": "menù",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "Cambia la password",
  "cp.components.passwordForgotSetPassword.matchError": "Le nuove password non coincidono",
  "cp.components.passwordForgotSetPassword.newPassword": "Nuova password",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "Nuova password (ripetizione)",
  "cp.components.passwordForgotSetPassword.newRequiredError": "È richiesta una nuova password",
  "cp.components.passwordForgotSetPassword.newToShortError": "La passwort inserita è troppo breve.",
  "cp.components.reminder.app.appAppStoreButton": "Vai all'App Store di Apple",
  "cp.components.reminder.app.appPlayStoreButton": "Vai su Google Play Store",
  "cp.components.reminder.app.content": "Per utilizzare CorPatch®, è necessaria l'app CorPatch®. Scaricalo dal Google Playstore o dall'App Store. \n",
  "cp.components.reminder.app.title": "Vuoi iniziare? Scarica l'App!",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "Benvenuto/a",
  "cp.components.resetPassword.changePasswordButton": "Cambia la password",
  "cp.components.resetPassword.currentPassword": "Password attuale",
  "cp.components.resetPassword.equalError": "La nuova password è uguale a quella vecchia",
  "cp.components.resetPassword.matchError": "Le nuove password non coincidono",
  "cp.components.resetPassword.newPassword": "Nuova password",
  "cp.components.resetPassword.newPasswordRepeat": "Nuova password (ripetizione)",
  "cp.components.resetPassword.newRequiredError": "È richiesta una nuova password",
  "cp.components.resetPassword.requiredError": "È richiesta la password attuale",
  "cp.components.resetPassword.setPasswordButton": "Impostare la password",
  "cp.components.singleTrainingsTable.shareDialogContent": "Seleziona l'istituto con cui desideri condividere questo corso di formazione:",
  "cp.components.singleTrainingsTable.shareDialogTitle": "Condividi la formazione",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "Condividi la formazione",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "Annulla",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "Condividere",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "Condivisa a: ",
  "cp.components.singleTrainingsTable.tableRowDate": "Data",
  "cp.components.singleTrainingsTable.tableRowDepth": "Profondità",
  "cp.components.singleTrainingsTable.tableRowFlow": "Flusso",
  "cp.components.singleTrainingsTable.tableRowFrequency": "Frequenza",
  "cp.components.singleTrainingsTable.tableRowOrigin": "Formazione",
  "cp.components.singleTrainingsTable.tableRowRecoil": "Rilascia",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "Condividi la formazione",
  "cp.components.userMenu.email": "Email",
  "cp.components.userMenu.logout": "Logout",
  "cp.components.userMenu.password": "Password",
  "cp.pages.acceptInvitation.button": "Alla pagina di login",
  "cp.pages.acceptInvitation.message": "Tutto pronto. Ora puoi iniziare!",
  "cp.pages.acceptInvitation.pageNotFound.message": "Questo invito non è più valido.",
  "cp.pages.acceptInvitation.pageNotFound.title": "Invito non trovato",
  "cp.pages.acceptInvitation.title": "Fatto.",
  "cp.pages.acceptInvitation.welcome": "Benvenuto/a",
  "cp.pages.adminInvite.errorSnackbar": "L'e-Mail {email} è già in uso",
  "cp.pages.adminInvite.inviteCardTitle": "Invita Admin",
  "cp.pages.adminInvite.successSnackbar": "Invia l'E-mail a {email}",
  "cp.pages.admins.adminsEmpty.button": "Invita admin",
  "cp.pages.admins.adminsEmpty.message": "Vuoi invitare il primo amministratore dell'istituto?",
  "cp.pages.admins.adminsEmpty.selected": "selezionato",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "E-mail",
  "cp.pages.admins.adminsEmpty.tableRowName": "Nome",
  "cp.pages.admins.adminsEmpty.title": "Nessun amministratore ancora!",
  "cp.pages.admins.adminsNotFound.message": "Questo istituto è stato eliminato. ",
  "cp.pages.admins.adminsNotFound.title": "Non trovato!",
  "cp.pages.admins.instituteAdmin": "Institute Admin",
  "cp.pages.admins.tableRowInstitute": "Istituto",
  "cp.pages.admins.title": "Admins",
  "cp.pages.course.cellDate": "Data",
  "cp.pages.course.cellDuration": "Durata",
  "cp.pages.course.cellFeedback": "Feedback",
  "cp.pages.course.cellName": "Nome",
  "cp.pages.course.rowDepth": "Profondità",
  "cp.pages.course.rowFlow": "Flusso",
  "cp.pages.course.rowFrequency": "Frequenza",
  "cp.pages.course.rowRecoil": "Rilascia",
  "cp.pages.course.title": "Corso",
  "cp.pages.course.trainees": "Tirocinanti",
  "cp.pages.courses.errorSnackbar": "Questo corso non può essere eliminato.",
  "cp.pages.courses.pageNotFoundMessage": "È stato eliminato. Ci dispiace :(",
  "cp.pages.courses.pageNotFoundTitle": "non trovato",
  "cp.pages.courses.pageTitle": "Corsi",
  "cp.pages.courses.roleInstituteAdmin": "Amministratore dell'istituto",
  "cp.pages.courses.roleTrainee": "Tirocinante",
  "cp.pages.courses.successSnackbar": "Il corso è stato eliminato con successo.",
  "cp.pages.dashboard.cpsCount": "dispositivi CorPatch® attivi",
  "cp.pages.dashboard.cpsCountRecently": "nuovo CorPatch® collegato",
  "cp.pages.dashboard.lastMonth": "Sviluppo nell'ultimo mese.",
  "cp.pages.dashboard.mobilesCount": "Tutti i cellulari riconosciuti",
  "cp.pages.dashboard.mobilesCountRecently": "cellulari recenti",
  "cp.pages.dashboard.pageTitle": "Statistica",
  "cp.pages.dashboard.trainingsCount": "formazione completata",
  "cp.pages.dashboard.usersCount": "importo totale di utenti registrati",
  "cp.pages.dashboard.usersCountRecently": "nuovi utenti registrati",
  "cp.pages.email.validation.button": "Vai al Login",
  "cp.pages.email.validation.text": "Grazie per aver verificato il tuo indirizzo E-mail. Lo useremo per proteggere il tuo account e tenerti aggiornato se lo desideri.",
  "cp.pages.export.pageTitle": "Esporta il corso",
  "cp.pages.homepage.title": "Pagina iniziale",
  "cp.pages.institute.PageNotFound.message": "Questo istituto è stato eliminato e non può essere più modificato.",
  "cp.pages.institute.PageNotFound.title": "Istituto non trovato.",
  "cp.pages.institute.institute": "Istituto",
  "cp.pages.institute.snackbarError": "Si è verificato un errore durante il salvataggio dell'istituto",
  "cp.pages.institute.snackbarSuccess": "Salvato",
  "cp.pages.institute.tabsAdmins": "Amministratori",
  "cp.pages.institute.tabsBaseData": "Dati di base",
  "cp.pages.institute.tabsTrainers": "Formatori",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "Fine: ",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "Non hai oggetti di condivisione attivi.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "Nessun oggetto di condivisione eliminato.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "Le azioni che stai cercando non esistono.",
  "cp.pages.instituteAdminShares.pageTitle": "Azioni",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "Non trovato",
  "cp.pages.instituteAdminShares.startDate": "Inizio: ",
  "cp.pages.institutes.addInstituteButton": "Aggiungi istituto",
  "cp.pages.institutes.deleteLabel": "elimina",
  "cp.pages.institutes.errorSnackbar": "L'istituto non può essere cancellato",
  "cp.pages.institutes.pageNotFound.message": "Vuoi aggiungere il primo istituto?",
  "cp.pages.institutes.pageNotFound.title": "Nessun istituto trovato",
  "cp.pages.institutes.pageTitle": "Istituti",
  "cp.pages.institutes.successSnackbar": "L'istituto è stato eliminato con successo",
  "cp.pages.institutesTable.deleteWarning": "Vuoi eliminare l'istituto selezionato? Tutti gli account e i dati associati andranno persi!",
  "cp.pages.institutesTable.instituteLowercase": "istituto",
  "cp.pages.institutesTable.institutesLowercase": "istituti",
  "cp.pages.institutesTable.tableRowCity": "Città",
  "cp.pages.institutesTable.tableRowCountry": "Paese",
  "cp.pages.institutesTable.tableRowInstitutes": "Istituti",
  "cp.pages.institutesTable.tableRowName": "Nome",
  "cp.pages.institutesTable.tableRowStreet": "Strada",
  "cp.pages.institutesTable.tableRowZIP": "CAP",
  "cp.pages.internalServerError.button": "Riprova",
  "cp.pages.internalServerError.message": "Il server non è riuscito a completare la richiesta. È un problema nostro. Per favore riprova più tardi.",
  "cp.pages.internalServerError.title": "Per favore, riprova più tardi.",
  "cp.pages.login.email": "E-mail",
  "cp.pages.login.loginButton": "Login",
  "cp.pages.login.loginInstitutesTitle": "Istituti",
  "cp.pages.login.password": "Password",
  "cp.pages.login.passwordForgot": "Hai dimenticato la password?",
  "cp.pages.login.registerButton": "Registrati",
  "cp.pages.login.termsOfUseButton": "Termini d'uso",
  "cp.pages.login.userNewlyRegisteredLabel1": "Sei stato/a registrato/a con successo.",
  "cp.pages.login.userNewlyRegisteredLabel2": "Non dimenticare di confermare il tuo indirizzo E-mail ed effettuare subito il login.",
  "cp.pages.login.userOrPasswordNotFound": "Utente o password non trovati",
  "cp.pages.login.validate.errorContent": "Forse hai provato ad accedere da un altro browser o dispositivo o hai chiuso il browser nel frattempo. Prova a richiedere un altro messaggio di posta elettronica per accedere.",
  "cp.pages.login.validate.errorSnackbar": "Si è verificato un errore durante l'accesso. Il tuo link potrebbe non essere aggiornato.",
  "cp.pages.login.validate.errorTitle": "Non siamo riusciti a riconoscere la sessione del browser",
  "cp.pages.login.validate.successContent": "Attendi qualche istante mentre convalidiamo il tuo login.",
  "cp.pages.login.validate.successTitle": "Ti stiamo effettuando il login.",
  "cp.pages.login.validate.validationButton": "Torna al login",
  "cp.pages.login.validate.validationContent": "Ti abbiamo inviato un'E-mail per verificare il tuo accesso.",
  "cp.pages.login.validate.validationTitle": "Verifica il tuo login",
  "cp.pages.logout.loginButton": "Accedi",
  "cp.pages.logout.message": "Arrivederci alla prossima",
  "cp.pages.logout.title": "Ciao!",
  "cp.pages.me.deleteOwnButtonConfirm": "Elimina il tuo account in modo permanente",
  "cp.pages.me.deleteOwnButtonRequest": "Elimina il tuo account in modo permanente",
  "cp.pages.me.deleteOwnContent": "Questa operazione eliminerà definitivamente il tuo account. Assicurati di aver salvato tutti i dati che potrebbero andare persi con l'eliminazione del tuo account. Tieni presente che non puoi annullare questa operazione.",
  "cp.pages.me.familyName": "Cognome",
  "cp.pages.me.firstName": "Nome di battesimo",
  "cp.pages.me.gender": "Genere",
  "cp.pages.me.genderFemale": "Femmina",
  "cp.pages.me.genderMale": "Maschio",
  "cp.pages.me.genderOther": "Altro",
  "cp.pages.me.notFoundTitle": "Impostazioni personali",
  "cp.pages.me.save": "Salva",
  "cp.pages.me.snackBarSaved.error": "Errore durante il salvataggio delle impostazioni personali",
  "cp.pages.me.snackBarSaved.saved": "Salvato",
  "cp.pages.me.title": "Impostazioni personali",
  "cp.pages.networkError.pageNotFound.button": "Riprova",
  "cp.pages.networkError.pageNotFound.message": "Il server non è riuscito a completare la richiesta. Sei connesso/a a Internet?",
  "cp.pages.networkError.pageNotFound.title": "Il server sembra non funzionare. Questo è su di noi! Riprova più tardi. ",
  "cp.pages.notFound.message": "Impossibile trovare questa pagina.",
  "cp.pages.notFound.title": "Non trovato.",
  "cp.pages.passwordForgot.confirmationMessage": "L'E-mail di verifica verrà inviata al tuo account.",
  "cp.pages.passwordForgot.confirmationMessage2": "Per favore controllalo.",
  "cp.pages.passwordForgot.confirmationSendMessage": "Ti abbiamo inviato una E-mail con un link per l'approvazione",
  "cp.pages.passwordForgot.confirmationSent": "Invia l'E-mail",
  "cp.pages.passwordForgot.confirmationTitle": "Reimposta la tua password",
  "cp.pages.passwordForgot.eMail": "E-mail",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "Torna al login",
  "cp.pages.passwordForgot.passwordForgotTitle": "Password dimenticata",
  "cp.pages.passwordForgotSetPassword.button": "Alla pagina di login",
  "cp.pages.passwordForgotSetPassword.message": "Tutto pronto. Adesso puoi partire!",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "Questo codice non è più valido.",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "Non più valido",
  "cp.pages.passwordForgotSetPassword.title": "Password cambiata!",
  "cp.pages.passwordForgotSetPassword.welcome": "Benvenuto/a",
  "cp.pages.register.acceptTermsOfUse": "Accetti i termini di utilizzo?",
  "cp.pages.register.create": "Crea un account",
  "cp.pages.register.emailField": "E-mail",
  "cp.pages.register.errorSnackbar": "Si è verificato un errore non intenzionale. Per favore riprova.",
  "cp.pages.register.firstnameField": "Nome di battesimo",
  "cp.pages.register.lastnameField": "Cognome",
  "cp.pages.register.newToShortError": "La passwort inserita è troppo breve.",
  "cp.pages.register.passwordField": "password",
  "cp.pages.register.successSnackbar": "La registrazione è andata a buon fine.",
  "cp.pages.settings.feedbackMode.menuItemExpert": "Barra",
  "cp.pages.settings.feedbackMode.menuItemNone": "Nessuno",
  "cp.pages.settings.feedbackMode.menuItemSimple": "Pompa",
  "cp.pages.settings.menuItemThresholdGood": "Soglia del feedback \"Buono\"",
  "cp.pages.settings.menuItemThresholdGreat": "Soglia del feedback \"Ottimo\"",
  "cp.pages.settings.resultType.menuItemExpert": "Esperto",
  "cp.pages.settings.resultType.menuItemNone": "Nessuno",
  "cp.pages.settings.resultType.menuItemSimple": "Semplice",
  "cp.pages.settings.resultType.menuItemStandard": "Standard",
  "cp.pages.settings.tableRowCompression": "Solo compressioni",
  "cp.pages.settings.tableRowDuration": "Durata della sessione",
  "cp.pages.settings.tableRowERC": "Controlla i segni vitali",
  "cp.pages.settings.tableRowFeedback": "Modalità di feedback",
  "cp.pages.settings.tableRowFrequency": "Frequenza target",
  "cp.pages.settings.tableRowLocked": "Bloccato",
  "cp.pages.settings.tableRowProperty": "Proprietà",
  "cp.pages.settings.tableRowResult": "Tipo di risultato",
  "cp.pages.settings.tableRowResultConfigSaveButton": "Salva la configurazione dei risultati",
  "cp.pages.settings.tableRowSaveButton": "Salva",
  "cp.pages.settings.tableRowTrainees": "Numero predefinito di tirocinanti",
  "cp.pages.settings.tableRowType": "Tipo di sessione",
  "cp.pages.settings.tableRowValue": "Valore",
  "cp.pages.settings.title": "Impostazioni del CorPatch® Trainer",
  "cp.pages.sharingObject.form.apiAccess": "Accesso alle API",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "Sei sicuro di voler eliminare l'oggetto di condivisione?",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "Questa azione non può essere annullata, ma nessun dato andrà perso. L'oggetto di condivisione verrà visualizzato come disattivato.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "Annulla",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "Rimuovi oggetto di condivisione",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "Elimina",
  "cp.pages.sharingObject.form.deleteButton": "Elimina",
  "cp.pages.sharingObject.form.disabled": "Disabilitati",
  "cp.pages.sharingObject.form.enabled": "Abilitato",
  "cp.pages.sharingObject.form.invitationCode": "Codice invito",
  "cp.pages.sharingObject.form.invitationLink": "Collegamento invito",
  "cp.pages.sharingObject.form.name": "Nome",
  "cp.pages.sharingObject.form.pullApiSecret": "Segreto",
  "cp.pages.sharingObject.form.pullUrl": "Estrai URL",
  "cp.pages.sharingObject.form.saveButton": "Salva",
  "cp.pages.sharingObject.form.title": "Oggetto di condivisione",
  "cp.pages.sharingObject.form.webHook": "Webhook",
  "cp.pages.sharingObject.pageNotFoundDescription": "Gli oggetti di condivisione che stai cercando non esistono.",
  "cp.pages.sharingObject.pageNotFoundTitle": "Non trovato",
  "cp.pages.sharingObject.pageTitle": "Condivisione di oggetti",
  "cp.pages.sharingObject.snackBarDeleteError": "Impossibile eliminare",
  "cp.pages.sharingObject.snackBarDeleted": "Cancellati",
  "cp.pages.sharingObject.snackBarSaveError": "Impossibile salvare",
  "cp.pages.sharingObject.snackBarSaved": "Salvato",
  "cp.pages.singleTraining.multipleTrainings": "Formazioni",
  "cp.pages.singleTraining.singleTraining": "Formazione",
  "cp.pages.singleTraining.table.created": "Creato",
  "cp.pages.singleTraining.table.name": "Nome completo",
  "cp.pages.singleTraining.table.selected": "selezionato",
  "cp.pages.singleTraining.title": "I tuoi allenamenti",
  "cp.pages.trainee.cpsButton": "Scarica i dati del CorPatch®",
  "cp.pages.trainee.delete.errorSnackbar": "Si è verificato un errore sconosciuto",
  "cp.pages.trainee.delete.successSnackbar": "I tirocinanti sono stati eliminati",
  "cp.pages.trainee.delete.warningSnackbar": "Uno o più utenti non sono stati eliminati",
  "cp.pages.trainee.deleteDialogButtonPrimary": "Elimina",
  "cp.pages.trainee.deleteDialogButtonSecondary": "Chiudi",
  "cp.pages.trainee.deleteLabel": "elimina",
  "cp.pages.trainee.mobileButton": "Scarica dati dello smartphone ",
  "cp.pages.trainee.multipleTrainees": "tirocinanti",
  "cp.pages.trainee.singleTrainee": "tirocinante",
  "cp.pages.trainee.table.created": "Creato",
  "cp.pages.trainee.table.email": "E-mail",
  "cp.pages.trainee.table.name": "Nome e cognome",
  "cp.pages.trainee.table.selected": "selezionato",
  "cp.pages.trainee.title": "Tirocinanti",
  "cp.pages.traineeShares.active": "Attivo",
  "cp.pages.traineeShares.addDialogAdd": "Aggiungi",
  "cp.pages.traineeShares.addDialogCancel": "Annulla",
  "cp.pages.traineeShares.addDialogDescription": "Inserisci il codice di invito che hai ricevuto dalla tua organizzazione partner:",
  "cp.pages.traineeShares.addDialogDescription2": "Se si sceglie di fare clic su \"Aggiungi\", si dichiara di accettare i termini e le condizioni e l'informativa sulla privacy forniti dall'organizzazione partner insieme al link/codice di invito. È essenziale leggerli e comprenderli prima di procedere.",
  "cp.pages.traineeShares.addDialogTitle": "Invito",
  "cp.pages.traineeShares.addShare": "Aggiungi Condividi",
  "cp.pages.traineeShares.deactivateDialogDescription": "Sei sicuro di voler disattivare questo accordo di condivisione con {instituteName}?",
  "cp.pages.traineeShares.deactivateDialogNo": "Annulla",
  "cp.pages.traineeShares.deactivateDialogTitle": "Disattiva",
  "cp.pages.traineeShares.deactivateDialogYes": "Disattiva",
  "cp.pages.traineeShares.deactivateTooltip": "Disattiva",
  "cp.pages.traineeShares.endDate": "Data di fine: ",
  "cp.pages.traineeShares.inactive": "Inattivo",
  "cp.pages.traineeShares.noActiveItemsMessage": "Al momento, non hai accettato alcun accordo di condivisione dei dati. Premi il pulsante «+» in basso a destra per inserire il codice di invito corrispondente.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "Nessun accordo di condivisione inattivo.",
  "cp.pages.traineeShares.pageNotFoundMessage": "Le azioni del tirocinante che stai cercando non esistono.",
  "cp.pages.traineeShares.pageTitle": "Azioni dei tirocinanti",
  "cp.pages.traineeShares.pageTitleNotFound": "Non trovato",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "Errore durante l'aggiunta dell'invito: {errorMessage}!",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "Errore durante la disattivazione della condivisione: {errorMessage}!",
  "cp.pages.traineeShares.snackBarInvalidCode": "Inserisci un codice di invito valido.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "Invito aggiunto",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "Condivisione disattivata",
  "cp.pages.traineeShares.startDate": "Data di inizio: ",
  "cp.pages.trainerInvite.errorSnackbar": "L'E-mail è già in uso",
  "cp.pages.trainerInvite.successSnackbar": "Invia un'E-mail a {email}",
  "cp.pages.trainerInvite.title": "Invita formatore",
  "cp.pages.trainers.errorSnackbar": "Impossibile eliminare l'utente. Riprova!",
  "cp.pages.trainers.successSnackbar": "Eliminato.",
  "cp.pages.trainersNotAvailable.button": "Invita formatore",
  "cp.pages.trainersNotAvailable.message": "Vuoi invitare il primo formatore?",
  "cp.pages.trainersNotAvailable.title": "Ancora nessun formatore!",
  "cp.pages.trainersNotFound.message": "Questo formatore è stato eliminato. Ci dispiace :(",
  "cp.pages.trainersNotFound.title": "Formatore non trovato",
  "cp.pages.trainersTable.deleteLabel": "elimina",
  "cp.pages.trainersTable.inviteTrainer": "Invita Formatore",
  "cp.pages.trainersTable.selected": "selezionato",
  "cp.pages.trainersTable.tableRowEmail": "E-mail",
  "cp.pages.trainersTable.tableRowName": "Nome",
  "cp.pages.trainersTable.trainers": "Formatori",
  "cp.pages.trainings.depth": "Depth",
  "cp.pages.trainings.flow": "Flow",
  "cp.pages.trainings.frequency": "Frequency",
  "cp.pages.trainings.notFound.message": "Has been deleted already. Sorry.",
  "cp.pages.trainings.notFound.title": "Not found",
  "cp.pages.trainings.recoil": "Recoil",
  "cp.pages.trainings.title": "Trainings",
  "cp.pages.trainings.trainee": "Trainee",
  "cp.pages.trainings.trainingNumber": "Training No.",
  "cp.pages.userChangeEmail.cancelButton": "Annulla",
  "cp.pages.userChangeEmail.changeEmail": "Cambia E-mail",
  "cp.pages.userChangeEmail.email": "Email",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "E-mail cambiata",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "Impossibile cambiare l'E-mail",
  "cp.pages.userChangeEmail.newEmail": "Nuova E-mail",
  "cp.pages.userChangeEmail.notFound.message": "Questo utente non esiste più.",
  "cp.pages.userChangeEmail.notFound.title": "Non trovato.",
  "cp.pages.userChangeEmail.ok": "OK",
  "cp.pages.userChangeEmail.sendEmail": "E-mail inviata",
  "cp.pages.userChangeEmail.verifyEmail.button": "Inviami una nuova E-mail di verifica al mio indirizzo",
  "cp.pages.userChangeEmail.verifyEmail.content": "Desideriamo tenerti informato sulle ultime modifiche alla nostra app e ai nostri prodotti. Pertanto dobbiamo verificare il tuo indirizzo E-mail.",
  "cp.pages.userChangeEmail.verifyEmail.title": "Verifica la tua E-mail",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "Impossibile cambiare la password:",
  "cp.pages.userChangePassword.notFound.message": "Questo utente è stato eliminato.",
  "cp.pages.userChangePassword.notFound.title": "Utente non trovato.",
  "cp.pages.userChangePassword.successSnackbar": "Password cambiata",
  "cp.pages.userChangePassword.title": "Cambia la password",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "La password attuale è errata",
  "cp.pages.userDetails.errorSnackbar": "L'invito non può essere inviato. ",
  "cp.pages.userDetails.invitation": "Invito",
  "cp.pages.userDetails.notFound.message": "Queste informazioni sono state eliminate. ",
  "cp.pages.userDetails.notFound.title": "Non trovato",
  "cp.pages.userDetails.sendInvitation": "Invia un invito",
  "cp.pages.userDetails.signUpAccepted": "Accettato",
  "cp.pages.userDetails.signUpPending": "In attesa",
  "cp.pages.userDetails.successSnackbar": "Invito inviato",
  "cp.pages.userDetails.userDetailsEmail": "E-mail"
}